import { observer } from 'mobx-react';
import * as React from 'react';
import GoogleTagManagerTooling from './GoogleTagManagerTooling';
import OneTrustTooling from './OneTrustTooling';

const Tooling: React.FC = () => {
  return (
    <>
      <OneTrustTooling />
      <GoogleTagManagerTooling />
    </>
  );
};

export default observer(Tooling);
